<template>
    <hts-slide-over
        :show="show"
        :rules="rules"
        :title="action === 'create' ? $t('labels.supplyInsurance.add') : $t('labels.supplyInsurance.edit')"
        :submit="onSubmit"
        @close="close">
        <template #body>
            <div class="hts-vehicles-ignore-add-vehicle">
                <div class="hts-vehicles-ignore-add-vehicle__container-body">
                    <div
                        class="grid gap-4 p-4"
                        :class="columnClass">
                        <hts-form-input
                            v-model="dataForm.vendor"
                            :label="$t('labels.supplyInsurance.vendor')"
                            :color="props.color"
                            required
                            prop="vendor"
                            name="vendor" />
                        <hts-form-input
                            v-model="dataForm.amount"
                            :label="$t('labels.supplyInsurance.amount')"
                            :color="props.color"
                            required
                            prop="amount"
                            name="amount" />
                        <hts-form-input
                            v-model="dataForm.expiredDate"
                            :label="$t('labels.supplyInsurance.expiredDate')"
                            :color="props.color"
                            type="date"
                            prop="expiredDate"
                            name="expiredDate" />
                        <hts-form-input
                            v-model="dataForm.description"
                            :label="$t('labels.supplyInsurance.description')"
                            :color="props.color"
                            prop="description"
                            name="description" />
                    </div>
                </div>
            </div>
        </template>
    </hts-slide-over>
</template>
<script lang="ts" setup>
import { ISupplyInsurance } from '../models/supply'

const emits = defineEmits(['close', 'on-submit'])
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  column: {
    type: Number,
    default: 1
  },
  color: {
    type: String,
    default: 'theme'
  },
  insuranceData: {
    type: Object as () => ISupplyInsurance,
    required: true
  },
  action: {
    type: String,
    default: 'create',
    required: true
  }
})

const rules = {
  vendor: 'required',
  amount: 'required|numeric'
}

const dataForm: ISupplyInsurance = reactive({ ...props.insuranceData })
const show = computed(() => {
  return props.show
})
const action = computed(() => {
  return props.action
})
const cleanData = (data: any) => {
  const temp = data
  if (action.value === 'create') {
    delete temp.ID
  }
  for (const propName in temp) {
    if (temp[propName] === '') {
      delete temp[propName]
    }
  }
  return temp
}
const onSubmit = () => {
  const data = cleanData(dataForm)
  emits('on-submit', data, props.action)
}
const close = () => {
  emits('close')
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-1'
})
</script>
